import { tv } from "@/utils/tv.config";
import type { VariantProps } from "tailwind-variants";

export const filedClasses = tv({
  slots: {
    root: [
      "Field__root",
      "group",
      "flex",
      "w-full",
      "flex-col",
      "items-start",
      "gap-1",
      "relative",
      "bg-common-white",
      "mb-2",
    ],
    label: [
      "text-sm font-medium",
      "text-gray-900",
      // "data-[invalid]:text-error-main",
    ],
    required: ["text-error-dark", "ml-1"],
    control: [
      "h-10",
      "w-full",
      "pl-3.5",
      "pr-2",
      "text-sm",
      "text-gray-900",
      "w-full",
      "bg-transparent",
      "border-none",
      "outline-none",
      "focus:ring-0",
      "focus:outline-none",
    ],
    error: "text-sm text-error-main",
    helpText: "text-xs text-gray-400",
    fieldWrapper: [
      "Field__wrapper",
      "flex",
      "items-center",
      "overflow-hidden",
      "w-full",
      "border-spacing-0.5",
      "border",
      "border-gray-300",
      "rounded-xl",
      "focus-within:outline-none",
      "focus-within:border-primary-main",
      "focus-within:ring-2",
      "focus-within:ring-primary-main/50",
      "group-data-[invalid]:border-error-main",
      "group-data-[invalid]:focus-within:ring-error-main/50",
    ],
    adornment: [
      "flex-shrink-0",
      "min-w-8",
      "flex",
      "items-center",
      "justify-center",
    ],
  },
  variants: {
    hasStartAdornment: {
      true: {
        control: "!pl-1",
        adornment: "ml-1",
      },
    },
    hasEndAdornment: {
      true: {
        control: "!pr-1",
        adornment: "mr-1",
      },
    },
    colSpan: {
      1: {
        root: ["col-span-1"],
      },
      2: {
        root: ["col-span-1", "sm:col-span-2"],
      },
      3: {
        root: ["col-span-1", "sm:col-span-3"],
      },
      4: {
        root: ["col-span-1", "sm:col-span-4"],
      },
      5: {
        root: ["col-span-1", "sm:col-span-5"],
      },
      6: {
        root: ["col-span-1", " sm:col-span-6"],
      },
    },
    required: {
      true: {
        label: ["after:content-['*'] after:ml-0.5 after:text-error-dark"],
      },
    },
    hidden: {
      true: {
        label: ["sr-only"],
      },
    },
    isFile: {
      true: {
        control: [
          "block",
          "w-full",
          "text-sm",
          "text-gray-500",
          "file:me-4",
          "file:mt-1",
          "file:py-2",
          "file:px-4",
          "file:rounded-lg",
          "file:border-0",
          "file:text-xs",
          "file:font-semi-bold",
          "file:bg-primary-main/10",
          "file:text-primary-main",
          "hover:file:bg-primary-main/15",
          "file:disabled:opacity-50",
          "file:disabled:pointer-events-none",
          // "mt-1",
          "!pl-1",
        ],
      },
    },
  },
});

export const {
  root: rootClasses,
  label: labelClasses,
  required: requiredClasses,
  control: controlClasses,
  fieldWrapper: fieldWrapperClasses,
  error: errorClasses,
  helpText: helpTextClasses,
  adornment: adornmentClasses,
} = filedClasses();

export type FieldVariantProps = VariantProps<typeof filedClasses>;
